interface TeamInterestInput {
    favouriteTeam?: string;
    teamInterest?: string;
}

interface TeamInterestPayload {
    teamInterestUpdate: boolean;
    teamInterestId: string | null;
}


export const getTeamInterestUpdatePayload = (
    submitData: TeamInterestInput,
    userData: TeamInterestInput & { teamInterestId?: string | null }
): TeamInterestPayload => {
    // User has set up team interest
    const isUserHasTeamInterest = !!userData.favouriteTeam && !!userData.teamInterestId;
    // User changed team interest
    const isUserChangedTeamInterest =
        submitData.favouriteTeam !== userData.favouriteTeam ||
        submitData.teamInterest !== userData.teamInterest;

    // User hasn't set team interest yet
    if (!isUserHasTeamInterest && isUserChangedTeamInterest) {
        return {
            teamInterestUpdate: true,
            teamInterestId: '',
        };
    }
    // User updated team interest
    if (isUserChangedTeamInterest) {
        return {
            teamInterestUpdate: true,
            teamInterestId: userData.teamInterestId ?? '',
        };
    }
    // Nothing has changed
    return {
        teamInterestUpdate: false,
        teamInterestId: userData.teamInterestId ?? '',
    };
};